const serviceDefaults = {
  ZG_PAYMENTS_ENABLED: false,
  ZG_APPLICATIONS_ENABLED: false,
  ZG_APPLICATIONS_VIEWABLE_GROUP: '',
  ZG_ANALYTICS_ENABLED: false,
  ZG_ANALYTICS_V2_ENABLED: false,
  ZG_BILLING_ENABLED: false,
  hostApp: 'none',
  fromApp: 'none',
};

const getServices = (
  cookies: Record<string, unknown> = {},
  query: Record<string, unknown> = {},
): Record<string, unknown> => {
  // eslint-disable-next-line camelcase
  const { ...prodServiceDefaults } = serviceDefaults;
  const availableFeatures = process.env.ZG_ENV === 'production' ? prodServiceDefaults : serviceDefaults;

  const services = {};
  Object.keys(availableFeatures).forEach((key) => {
    // set value to default
    let value = availableFeatures[key];

    // if feature exists as a cookie, set that here.
    if (cookies[key]) {
      value = cookies[key];
    }

    // if feature exists as a query, it overrides the cookie.
    if (query[key]) {
      value = query[key];
    }
    try {
      services[key] = JSON.parse(value); // booleans
    } catch (error) {
      services[key] = value; // strings
    }
  });
  return services;
};

export { getServices };
